import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';
import Vue from 'vue';

const createFeedbackVueSchema = {
  ...queryBuilder.properties({
    eventRating: { title: Vue.$t('page.dashboard.companies.feedbacks.eventRating.validation'), required: true },
    reparticipationRating: { title: Vue.$t('page.dashboard.companies.feedbacks.reparticipationRating.validation'), required: true },
    youthVisitorsCount: {
      type: 'number', required: true, maximum: 2147483647, minimum: 0,
    },
    adultVisitorsCount: {
      type: 'number', required: false, maximum: 2147483647, minimum: 0,
    },
    remark: { type: 'string', required: false, maxLength: 500 },
  }),
};

export default createFeedbackVueSchema;
